// SPDX-FileCopyrightText: 2026 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { Colors } from '@tls/treact-ui';
import React from 'react';
import styled from 'styled-components';

// Wraps filter matches in a yellow mark; case-insensitive, keeps original casing.
export default function HighlightText({ text, query }: Readonly<{ text?: string; query?: string }>) {
  if (!text) return null;
  if (!query) return <>{text}</>;
  const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`);
  const q = query.toLocaleLowerCase();
  // Key on character offset (unique per match), not the array index.
  let offset = 0;
  const segments = text.split(new RegExp(`(${escaped})`, 'gi')).map(part => {
    const start = offset;
    offset += part.length;
    return { part, start };
  });
  return (
    <>{segments.map(({ part, start }) => (part.toLocaleLowerCase() === q ? <Mark key={start}>{part}</Mark> : part))}</>
  );
}

const Mark = styled.mark`
  background-color: ${Colors.tryellow.hex};
  color: inherit;
`;
